import Cookies from 'universal-cookie';
export const cookie = new Cookies();